<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="share-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    @show.modal="hidePaymentModal"
  >
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title class-title" id="exampleModalLongTitle">
            Academia
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="text-center" id="share-content"></div>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->

  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="share-web-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    @show.modal="hidePaymentModal"
  >
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title class-title" id="exampleModalLongTitle">
            Academia
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="text-center" id="share-web-content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "VideoClass",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      isLoading: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
